import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from '../auth-guard.service';
import { ContestWiseComponent } from './insurerDashboard/contestWise/contestWise.component';
import { IncomeVsExpenseComponent } from './insurerDashboard/incomeVsExpense/incomeVsExpense.component';
import { DashboardLandingPageComponent } from './dashboard-landing-page/dashboard-landing-page.component';
import { PerformanceLandingPageComponent } from './performance-landing-page/performance-landing-page.component';

const routes: Routes = [
  {
    path: 'newbusinessanalysis',
    component: DashboardLandingPageComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'newbusinessbrokeranalysis',
    component: DashboardLandingPageComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'performance',
    component: PerformanceLandingPageComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'insurerperformance',
    component: PerformanceLandingPageComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'incomeVsExpense',
    component: IncomeVsExpenseComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'contestWise',
    component: ContestWiseComponent,
    canActivate: [AuthGuardService],
  },
  // {
  //   path: 'notificationsAPI',
  //   component: NotificationsTestApiStepFormComponent,
  //   canActivate: [AuthGuardService],
  // },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DashboardRoutingModule {}
